import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: data,
});
export const fetchApplied = (applied: any) => ({
    type: 'FETCH_APPLIED_SUCCESS',
    payload: applied,
});
export const getcou = (country: any) => ({
    type: 'FETCH_COUNTRY_SUCCESS',
    payload: country,
});
export const getsta = (state: any) => ({
    type: 'FETCH_STATE_SUCCESS',
    payload: state,
});
export const getname = (name: any) => ({
    type: 'FETCH_NAME_SUCCESS',
    payload: name,
});
export const state = (hcountry: any) => ({
    type: 'FETCH_SNAME_SUCCESS',
    payload: hcountry,
});
export const image = (image: any) => ({
    type: 'FETCH_IMAGE_SUCCESS',
    payload: image,
});
export const himage = (himage: any) => ({
    type: 'FETCH_HIMAGE_SUCCESS',
    payload: himage,
});



export const fetchDoctorDatasss = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = SUPRIVISOR_API.sdoctordata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAppliedData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,userid:uid};
            const apiname = SUPRIVISOR_API.sapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApplied(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getCountry = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = SUPRIVISOR_API.getcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getcou(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getState = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,countryId:country};
            const apiname = SUPRIVISOR_API.getstate;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getsta(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getcountryname = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:15,country:country};
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname,payload);
            dispatch(getname(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const gethcountryname = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:15,country:country};
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname,payload);
            dispatch(state(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const apiname = SUPRIVISOR_API.profilepic;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(image(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadHImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = SUPRIVISOR_API.hospitalimage;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(himage(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

